import styled from 'styled-components'
import { CalendarEvent } from './AdRecruitCalendar'
import { Schedule } from './useLoadRecruitSchedule';
import { Icon_AddCircle, Icon_EdgeFoldPaper, Icon_Flag, Icon_StarShield } from '../common/CommonIcons';
import { format } from 'date-fns';

const HeaderWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;

    width: 100%;
    font-size: 18px;
    font-weight: 600;
`
const ColorBox = styled.div<{ color: string }>`
  width: 24px;
  height: 24px;
  border-radius: 2px;
  background-color: ${({ color }) => color};
`;
const DateWrapper = styled.div` 
    display: flex;
    gap: 8px;
`
const PageContainer = styled('div')({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    flexDirection: 'column',

    width:'100%',
    gap:'18px'
})

const CircleWrapper = styled('div')({
    display: 'flex',
    // justifyContent:'center',
    alignItems: 'center',
    position: 'relative',
  });

interface CircleProps{
    isNow? : boolean
}

const Circle = styled('div')<CircleProps>(({ isNow }) => ({
  display:'flex',
  justifyContent:'center',
  alignItems:'center',

  zIndex:1,
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  ...(isNow
    ? {
        backgroundColor: '#FFF',
        border: '0.5px solid #31F2BD',
        filter: 'drop-shadow(0px 0px 4px rgba(49, 242, 189, 0.8))',
      }
    : {
        backgroundColor: '#189187',
      }),
  }));
  
  const Line = styled('div')({
    position:'absolute',
    width: '100%',
    backgroundColor: 'black',
    flexGrow: 1,
    marginLeft: '4px', // 바로 이어붙이기
    border:'1px solid #ACACAC',
    top: '-23px',
    left : '50%'
  });
  interface SessionWrapperProps {
    now: string;
  }
  const SessionWrapper = styled('div')<SessionWrapperProps>(({ now })=>({
    position:'relative',
    display: 'flex',
    flexDirection:'column',
    justifyContent:'flex-start',
    alignItems:'center',
    // gap:'4px',

    padding:'6px 11px',
    minHeight:'100px',
    width:'100%',
    color:(now === '입영일' || now === '임관일') ? '#0B4D3C' : 'white',
    fontWeight:600,
    fontSize:'12px',
    borderRadius:'4px',
    backgroundColor:
    now === '추가과정'
        ? '#117E61' // 추가접수 배경
        : now === '입영일'
        ? '#49CDAA' // 입영일 배경
        : now === '임관일'
        ? '#A4E6D5' // 임관일 배경
        : now === '접수'
        ? '#0B4D3C' // 접수 배경
        : '#FFFFFF', // 기본 배경
  }))
const DateContainter = styled('div')({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    flexDirection:'column',
})
const mapImg = (now:string)=>{
    switch (now) {
        case '추가과정':
          return <Icon_AddCircle style={{scale:(0.7)}}/>
        case '입영일':
          return <Icon_Flag style={{width:'14px', height:'auto', margin:'4px'}}/>
        case '임관일':
          return <Icon_StarShield style={{width:'14px', height:'auto', margin:'4px'}}/>
        case '접수':
          return <Icon_EdgeFoldPaper style={{scale:(0.7)}}/>
        default:
          return '';
      }
}
interface Props{
    item : CalendarEvent
    schedules : Schedule[]
}
const AdRecrutSession = ({item, schedules}:Props) => {
    const BoxbgColor : Record<string, string> = {
        '접수': '#0B4D3C',
        '추가과정': '#117E61',
        '입영일': '#49CDAA',
        '임관일': '#A4E6D5',
    };
    const parseCourseName = (name: string) => {
        return name === '입영일' || name === '임관일' || name === '접수' ? name : '추가과정';
    };
    return (
        <>
            <HeaderWrapper>
                <ColorBox color={BoxbgColor[item.course_type]}/>
                <div>{item.course_name}</div>
            </HeaderWrapper>
            <div style={{marginLeft:'32px'}}>{format(new Date(item.start), 'MM월 dd일')} ~ {format(new Date(item.end), 'MM월 dd일')}</div>
            <DateWrapper>
                {schedules?.map((content:Schedule,index:any)=>{
                    const parsedName = parseCourseName(content.course_name)
                    return(
                        <PageContainer>
                            <CircleWrapper>
                                <Circle   isNow={ parsedName === item.course_type && (parsedName !== '추가과정' || item.course_name === content.course_name) }>
                                {parsedName === item.course_type &&
                                    (parsedName !== '추가과정' || item.course_name === content.course_name) && (
                                    <Circle style={{width:'6px', height:'6px', backgroundColor:'#31F2BD'}}/>
                                )}
                                </Circle>
                            </CircleWrapper>
                            <SessionWrapper now={parsedName}>
                                {index !== schedules.length - 1 && <Line />} {/* 마지막에는 Line 안나오게 */}
                                {mapImg(parsedName)}
                                {content.course_name}
                                {content.start_date ? 
                                    <DateContainter>
                                        <div>
                                        {format(new Date(content.start_date), 'MM월 dd일')}</div>
                                        <div style={{margin:'-4px'}}>~</div>
                                        <div>
                                        {format(new Date(content.end_date), 'MM월 dd일')}</div>
                                    </DateContainter>:
                                    <div style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                                        {format(new Date(content.end_date), 'MM월 dd일')}
                                    </div>}
                            </SessionWrapper>
                    </PageContainer>
                    )})}
            </DateWrapper>
        </>
    )
}

export default AdRecrutSession